import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

interface TickerItem {
  tag: string;
  text: string;
  slug: string;
}

const items: TickerItem[] = articles.slice(0, 6).map((a) => ({
  tag: a.catName,
  text: a.title,
  slug: a.slug,
}));

const loop: TickerItem[] = [...items, ...items];

export default function Ticker() {
  return (
    <div className="flex items-stretch gap-0 border-b border-background-200/70 bg-background-100/60 overflow-hidden">
      <div className="relative z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-3 py-2.5 text-background-50 md:px-4">
        <span className="flex h-2 w-2 animate-pulse-soft rounded-full bg-background-50" aria-hidden="true"></span>
        <span className="whitespace-nowrap text-sm font-semibold">实时快讯</span>
      </div>
      <div className="relative flex flex-1 items-center overflow-hidden px-2">
        <div className="flex shrink-0 animate-ticker items-center gap-10 whitespace-nowrap py-2.5 pl-6">
          {loop.map((it, i) => (
            <Link
              key={`${it.slug}-${i}`}
              to={`/article/${it.slug}`}
              className="inline-flex items-center gap-2.5 text-sm text-foreground-700 hover:text-primary-700"
            >
              <span className="rounded-md bg-background-200 px-1.5 py-0.5 text-xs text-foreground-700">{it.tag}</span>
              {it.text}
              <i className="ri-arrow-right-line text-foreground-400" aria-hidden="true"></i>
            </Link>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background-100/90 to-transparent" />
      </div>
    </div>
  );
}